<template>
  <br />
  <div class="container" style="text-align: center" v-if="workExp.length == 0">
    <div class="spinner-border" role="status">
      <span class="visually-hidden">Loading...</span>
    </div>
  </div>
  <div class="container">
    <div v-if="workExp.length > 0" class="row row-cols-2">
      <div v-for="item of workExp" :key="item.id" class="col">
        <div class="card mb-3 shadow rounded">
          <div class="row g-0">
            <div class="col-md-4">
              <img :src="item.logo" class="card-img-top cardImage" alt="..." />
            </div>
            <div class="col-md-8">
              <div class="card-body">
                <h5 class="card-title">
                  <b>{{ item.title }} - {{ item.company_name }}</b>
                </h5>
                <p class="card-text text-muted spanText">
                  {{ item.from }} - {{ item.to }}
                </p>

                <ul>
                  <li v-for="ld in item.desc" :key="ld[0]" class="spanText">
                    {{ ld }}
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import db from "../db.js";
export default {
  name: "WorkExperience",
  data: function () {
    return {
      workExp: [],
    };
  },
  mounted() {
    db.collection("experiences")
      .orderBy("id", "desc")
      .onSnapshot((snapshot) => {
        const snapData = [];
        snapshot.docs.forEach((doc) => {
          snapData.push(doc.data());
        });
        this.workExp = snapData;
      });
  },
};
</script>


<style lang="scss" scoped>
* {
  font-family: "Courier New", Courier, monospace;
}
.spanText {
  font-size: 14px;
  // font-family: sans-serif;
}

.cardImage {
  width: 10rem;
  height: 10rem;
  object-fit: contain;
  text-align: center;
  padding: 1rem;
}
</style>